/* eslint-disable */
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Fade from 'react-reveal/Fade';
import { useTranslation } from "react-i18next";

import CardLong from '../../components/card-long'
import { TitleOne, TextBodyOne, BorderText } from '../../components/text'
import ic1 from '../../static/icons/advantage/auto/ic-1.svg'
import ic2 from '../../static/icons/advantage/auto/ic-2.svg'
import ic3 from '../../static/icons/advantage/auto/ic-3.svg'
import image from '../../static/icons/advantage/auto/image.svg'
import { Style } from './vendor.styles'

const VendorFix = () => {
  const { t } = useTranslation();

  return (
    <Style>
      <Grid>
        <Row middle="lg">
          <Col sm={12} xs={12} lg={6} className="col-vendor">
            <div className="image-top">
              <img
                className="image-auto"
                src={image}
                alt="halojasa/salon-mobil"
              />
            </div>
          </Col>
          <Col
            sm={12}
            xs={12}
            lg={6}
            className="col-vendor bottom-margin"
          >
            <Row>
              <Col sm={12} xs={12} lg={12}>
                <TitleOne display="block" align="left">
                  {t('pageSalonMobilPangilan.part32')}
                </TitleOne>
                <div className="auto-margin">
                  <TextBodyOne display="block" align="left">
                    {t('pageSalonMobilPangilan.part33')}
                  </TextBodyOne>
                </div>
                <div className="auto-display">
                  <Fade left>
                    <BorderText background="linear-gradient(279deg, #ff7dcf, #5069bb)"></BorderText>
                  </Fade>
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={12} xs={12} lg={12}>
                <CardLong
                  className="card-long-box"
                  imageSize="81px"
                  padding="30px 0"
                  border="transparent"
                  shadow="rgba(0, 0, 0, 0)"
                  options={{
                    image: ic1,
                    title: t('pageSalonMobilPangilan.part34'),
                    desc: t('pageSalonMobilPangilan.part35')
                  }}
                ></CardLong>
              </Col>
            </Row>
            <Row>
              <Col sm={12} xs={12} lg={12} md={12}>
                <CardLong
                  className="card-long-box"
                  imageSize="81px"
                  padding="30px 0"
                  border="transparent"
                  shadow="rgba(0, 0, 0, 0)"
                  options={{
                    image: ic2,
                    title: t('pageSalonMobilPangilan.part36'),
                    desc: t('pageSalonMobilPangilan.part37')
                  }}
                ></CardLong>
              </Col>
            </Row>
            <Row>
              <Col sm={12} xs={12} lg={12} md={12}>
                <CardLong
                  className="card-long-box"
                  imageSize="81px"
                  padding="30px 0"
                  border="transparent"
                  shadow="rgba(0, 0, 0, 0)"
                  options={{
                    image: ic3,
                    title: t('pageSalonMobilPangilan.part38'),
                    desc: t('pageSalonMobilPangilan.part39')
                  }}
                ></CardLong>
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default VendorFix
